import { render, staticRenderFns } from "./LoginPop.vue?vue&type=template&id=c9b20dc2"
import script from "./LoginPop.vue?vue&type=script&lang=js"
export * from "./LoginPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports